export default "__VITE_ASSET__CWWud$ci__"